import React from 'react'

import Grid, { Col } from '../../../../../components/pdf/Grid'
import Image from '../../../../../components/pdf/Image'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import { formatDate } from '@btime/helpers'

const Cover = ({ place }) => {
  const issueDate = formatDate('DD/MM/YYYY', new Date())

  return (
    <View pageBreakAfter style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column' }}>
      <Grid justify={'space-between'}>
        <Image width={150} src={'/pdfs/teste/epsso.png'} />
        <Text>Emitido em {issueDate}</Text>
      </Grid>

      <Grid direction="column" align="start" justify="center" style={{ flex: 1 }}>
        <Col>
          <Text size={60} bold>
            AET
          </Text>
          <Text size={20}>-</Text>
          <Text size={20} bold>
            Avaliação Ergonômica do Trabalho
          </Text>
          <Text size={20}>Inventário de Riscos Ergonômicos e Plano de ação</Text>
          <Text size={20}>-</Text>
          <Text size={20} bold>
            {place}
          </Text>
          <Text size={20}>-</Text>
          <Text size={20}>-</Text>
        </Col>
      </Grid>
    </View>
  )
}

export default Cover
